export const UPDATE_WORKPLAN_PUBLISH_PROGRESS = 'UPDATE_WORKPLAN_PUBLISH_PROGRESS';
